import { CircleButtonAnimation } from '../utils/CircleButtonAnimation';

export const CircleButtonController = () => {
  const $icons = $('.icn-circle');
  const circlSVG = '<svg width="54px" height="54px" viewBox="0 0 54 54" class="circle-anim"><circle class="circle" cx="27" cy="27" r="25" stroke-dasharray="160" stroke-dashoffset="160"/></svg>';


  $icons.each((i, el) => {

    const $this = $(el);
    const $button = $this.parent();

    $this.append(circlSVG);

    CircleButtonAnimation($button);
  });



}



// WEBPACK FOOTER //
// ./src/js/controllers/CircleButtonController.js